<template>
  <add-edit-dialog v-show="visible">
    <crm-panel title="编辑政府客户">
      <div class="page-buttons">
        <crm-button
          :text="'保存'"
          @click="handleSave()">
        </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCancel()">
        </crm-button>
      </div>
      <el-form
        label-width="160px"
        ref="form"
        :model="form"
        :rules="formRules"
        class="add-edit-form">
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="客户姓名：" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考察日期：" prop="inspectDate">
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="form.inspectDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="考察性质：" prop="inspectQuality">
              <el-select clearable v-model="form.inspectQuality">
                <el-option
                  v-for="item in investigationNature"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考察类别：" prop="inspectType">
              <el-select clearable v-model="form.inspectType">
                <el-option
                  v-for="item in investigatType"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="业务线：" prop="lines4Busi">
              <el-cascader
                :options="[busiLine]"
                :props="{ checkStrictly: true, emitPath: false }"
                clearable
                placeholder="业务线"
                v-model="form.lines4Busi"
                @change="changeParentTeam">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考察目的：" prop="inspectPurpose">
              <el-input
                type="textarea"
                :rows="4"
                v-model="form.inspectPurpose">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="接待等级：" prop="receptionLevel">
              <el-select clearable v-model="form.receptionLevel">
                <el-option
                  v-for="item in receptionLevel"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="接待人：" prop="receptionPeople">
              <el-input v-model="form.receptionPeople"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="讲解人：" prop="explainer">
              <el-input v-model="form.explainer"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="去访人：" prop="visitPeople">
              <el-input v-model="form.visitPeople"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="考察申请人：" prop="inspectApplicant">
              <el-input v-model="form.inspectApplicant"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="auth.govPerson && auth.govPerson.toggleStatus">
          <el-col :span="18" :offset="3">
            <el-form-item label="考察人员：" prop="inspectPersonnel">
              <crm-button :text="'添加'" @click="toAdd()"></crm-button>
              <el-table
                :data="form.inspectPersonnel"
                border
                fit
                style="width: 100%">
                <el-table-column
                  prop="cluesName"
                  label="姓名"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="cluesCompany"
                  label="公司"
                  width="200"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="isLeader"
                  label="是否为主要领导"
                  align="center">
                  <template slot-scope="{row}">
                    <el-checkbox v-model="row.isLeader"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed="right"
                  align="center"
                  label="操作">
                  <template slot-scope="{row}">
                    <el-button
                      @click="handleDelete(row)"
                      type="text"
                      size="small">
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </crm-panel>

    <investigator-list :visible="addVisible" @save="handleSaveInvestigator" @close="addVisible = false"></investigator-list>

  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import InvestigatorList from './investigator-list';

export default {
  props: {
    visible: Boolean,
    id: String,
  },
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    InvestigatorList,
  },
  data() {
    return {
      form: {},
      formRules: {
        name: [
          { required: true, message: '请填写客户名称', trigger: 'blur' },
          { max: 50, message: '最多50个字', trigger: 'blur' },
        ],
        inspectDate: [{ required: true, message: '请选择考察日期', trigger: 'change' }],
        inspectQuality: [{ required: true, message: '请选择考察性质', trigger: 'change' }],
        inspectType: [{ required: true, message: '请选择考察类别', trigger: 'change' }],
        lines4Busi: [{ required: true, message: '请选择业务线', trigger: 'change' }],
        inspectPurpose: [
          { required: true, message: '请填写考察目的', trigger: 'blur' },
          { max: 200, message: '最多200个字', trigger: 'blur' },
        ],
        receptionPeople: [{ max: 10, message: '最多10个字', trigger: 'blur' }],
        explainer: [{ max: 10, message: '最多10个字', trigger: 'blur' }],
        visitPeople: [{ max: 10, message: '最多10个字', trigger: 'blur' }],
        inspectApplican: [{ max: 10, message: '最多10个字', trigger: 'blur' }],
        inspectPersonnel: [{ required: true, message: '请选择考察人员', trigger: 'change' }],
      },
      addVisible: false,
      BusilineLabel: {},
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      investigationNature: 'common/investigationNature',
      investigatType: 'common/investigatType',
      receptionLevel: 'common/receptionLevel',
      busiLine: 'customer/busiLine',
      governmentDetail: 'customer/governmentDetail',
    }),
  },
  watch: {
    visible(val) {
      if (val && !this.investigationNature.length) this.handleGetInvNature();
      if (val && !this.investigatType.length) this.handleGetInvCategory();
      if (val && !this.receptionLevel.length) this.handleGetReceptionLevel();
      if (val && !this.busiLine.chidren) this.handleGetBusiLine();
      if (val && this.id) this.handleGetDetail();
    },
  },
  methods: {
    ...mapActions({
      getInvestigationNature: 'common/getInvestigationNature',
      getInvestigationCategory: 'common/getInvestigationCategory',
      getReceptionLevel: 'common/getReceptionLevel',
      getBusiLine: 'customer/getBusiLine',
      editGovernmentCus: 'customer/editGovernmentCus',
      getGovernmentDetail: 'customer/getGovernmentDetail',
    }),
    changeParentTeam(team) {
      this.form.lines4Busi = team;
      this.form.lines4BusiName = this.BusilineLabel[this.form.lines4Busi];
    },
    toAdd() {
      this.addVisible = true;
    },
    handleSaveInvestigator(investigator) {
      this.form.inspectPersonnel = this.form.inspectPersonnel.concat(investigator);
      if (this.form.inspectPersonnel.length > 0) {
        this.$refs.form.fields.find(item => item.prop === 'inspectPersonnel').clearValidate();
      }
    },
    handleDelete(row) {
      const index = this.form.inspectPersonnel.findIndex(item => item.cluesId === row.cluesId);
      this.form.inspectPersonnel.splice(index, 1);
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.inspectPersonnel.forEach((item) => {
            item.isLeader = Number(item.isLeader);
          });
          this.form.delInspectPersonnel = [];
          this.governmentDetail.personnelList.forEach((item) => {
            const findItem = this.form.inspectPersonnel
              .find(finaItem => finaItem.id === item.id);
            if (!findItem) this.form.delInspectPersonnel.push(item.id);
          });
          this.editGovernmentCus(this.form).then(() => {
            this.$message.success('编辑成功！');
            this.$emit('success');
            this.$emit('close');
          }).catch(() => {});
        }
      });
    },
    handleCancel() {
      this.$emit('close');
    },
    handleGetInvNature() {
      this.getInvestigationNature({
        pageNumber: 1,
        pageSize: 100,
        code: 'category_inspect_quality',
      });
    },
    handleGetInvCategory() {
      this.getInvestigationCategory({
        pageNumber: 1,
        pageSize: 100,
        code: 'category_inspect_type',
      });
    },
    handleGetReceptionLevel() {
      this.getReceptionLevel({
        pageNumber: 1,
        pageSize: 100,
        code: 'category_reception_level',
      });
    },
    handleGetBusiLine() {
      this.getBusiLine().then(() => {
        this.handleTreeData([this.busiLine]);
      });
    },
    handleTreeData(data) {
      data.forEach((item) => {
        this.BusilineLabel[item.value] = item.label;
        if (item.children && item.children.length) this.handleTreeData(item.children);
      });
    },
    handleGetDetail() {
      this.getGovernmentDetail({ id: this.id }).then(() => {
        this.form = this.governmentDetail;
        this.$set(this.form, 'inspectPersonnel', []);
        this.governmentDetail.personnelList.forEach((item) => {
          this.form.inspectPersonnel.push({
            ...item,
            isLeader: !!item.isLeader,
          });
        });
      });
    },
  },
};
</script>

<style>

</style>
